exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3GpPr5vaPyy3rqR0uBPero {\n  font-size: 1rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n._2TtusAU_vedudSEtmSwPXv {\n  margin: 0 auto;\n}\n", ""]);
// Exports
exports.locals = {
	"compactText": "_3GpPr5vaPyy3rqR0uBPero",
	"centered": "_2TtusAU_vedudSEtmSwPXv"
};